import { Star, Camera } from "lucide-react";
import { Reveal, SectionHeading } from "@/components/Reveal";
import { IMG } from "@/lib/site";

const PLACEHOLDERS = [1, 2, 3];

const WALL = [
  { src: IMG.texture, alt: "Golden ghee texture swirl" },
  { src: IMG.cuisine, alt: "Indian dish finished with ghee" },
  { src: IMG.lifestyle, alt: "MAHIRA ghee jar in a warm kitchen" },
  { src: IMG.jar, alt: "Premium glass jar of golden ghee" },
];

export default function Reviews() {
  return (
    <section id="reviews" data-testid="reviews-section" className="bg-ivory py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-5 md:px-10">
        <SectionHeading eyebrow="Social Proof" title="Loved by MAHIRA Customers">
          We publish only genuine customer reviews. As our first families share
          their experiences, their words will appear here — unedited and
          honest.
        </SectionHeading>

        <div className="mt-16 grid gap-5 md:grid-cols-3">
          {PLACEHOLDERS.map((n) => (
            <Reveal key={n} delay={n * 0.08}>
              <div
                data-testid={`review-placeholder-${n}`}
                className="flex h-full flex-col rounded-3xl border border-dashed border-forest/25 bg-white/40 p-8"
              >
                <div className="flex items-center justify-between">
                  <div className="flex gap-1 text-gold/60">
                    {Array.from({ length: 5 }).map((_, i) => (
                      <Star key={i} className="h-4 w-4" />
                    ))}
                  </div>
                  <span className="rounded-full bg-gold-light/50 px-3 py-1 text-[10px] font-semibold uppercase tracking-[0.2em] text-forest/70">
                    Placeholder
                  </span>
                </div>
                <p className="mt-6 flex-1 font-heading text-xl italic leading-relaxed text-charcoal/45">
                  “A genuine customer review will appear here once MAHIRA
                  families share their experience.”
                </p>
                <div className="mt-6 flex items-center gap-3">
                  <span className="flex h-10 w-10 items-center justify-center rounded-full bg-forest/10 text-xs font-bold text-forest">
                    M
                  </span>
                  <div>
                    <p className="text-sm font-semibold text-charcoal/50">Customer Name</p>
                    <p className="text-xs text-charcoal/40">Verified Buyer</p>
                  </div>
                </div>
              </div>
            </Reveal>
          ))}
        </div>

        <div className="mt-24">
          <Reveal>
            <div className="flex flex-wrap items-end justify-between gap-4">
              <h3 className="font-heading text-3xl text-forest md:text-4xl">
                Customer Photo Wall
              </h3>
              <p className="text-sm text-charcoal/60">
                Tag <span className="font-semibold text-forest">#MyMahira</span> to be featured
              </p>
            </div>
          </Reveal>
          <div className="mt-8 grid grid-cols-2 gap-4 lg:grid-cols-4">
            {WALL.map((img, i) => (
              <Reveal key={img.src} delay={i * 0.07}>
                <div
                  data-testid={`photo-wall-${i + 1}`}
                  className="group relative overflow-hidden rounded-3xl"
                >
                  <img
                    src={img.src}
                    alt={img.alt}
                    loading="lazy"
                    className="aspect-square w-full object-cover transition-transform duration-700 ease-out group-hover:scale-110"
                  />
                  <div className="absolute inset-0 flex items-end bg-forest/0 p-5 transition-[background-color] duration-500 group-hover:bg-forest/45">
                    <span className="flex translate-y-3 items-center gap-2 text-[11px] font-semibold uppercase tracking-[0.2em] text-ivory opacity-0 transition-[opacity,transform] duration-500 group-hover:translate-y-0 group-hover:opacity-100">
                      <Camera className="h-4 w-4" /> #MyMahira
                    </span>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
          <Reveal delay={0.1}>
            <p className="mt-5 text-xs uppercase tracking-[0.25em] text-charcoal/45">
              Authentic customer moments — coming soon
            </p>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
